import { loadView } from '@/helper/utils'
import { plainLayout } from '@/components/layouts/Plain'

export default {
  path: '/restriction',
  component: plainLayout(loadView('restriction/Restriction')),
  children: [
    {
      path: '',
      name: 'RestrictionLock',
      component: loadView('restriction/RestrictionLock'),
      meta: { requiresAuth: true }
    },
    {
      path: 'deleted',
      name: 'RestrictionWithdrawal',
      component: loadView('restriction/RestrictionWithdrawal'),
      meta: { requiresAuth: true }
    },
    {
      path: 'service_is_over',
      name: 'RestrictionBlack',
      component: loadView('restriction/RestrictionBlack'),
      meta: { requiresAuth: true }
    }
  ]
}
